<template>
  <div>
    <close-button @click="$emit('close')" class="close-button"></close-button>

    <div class="dialog-header">
      <h1>Uw browser is verouderd</h1>
    </div>

    <div class="dialog-content">
      Met een verouderde browser kunt u onze website helaas niet meer (goed)
      gebruiken.<br />
      Om optimaal van onze website gebruik te kunnen maken raden wij u daarom
      aan over te stappen op een moderne browser.
      <br /><br />
      <a href="https://browsehappy.com/" target="_blank"
        >Een overzicht van moderne browsers vindt u hier.</a
      >
    </div>
  </div>
</template>
<script>

export default {
  name: 'OldBrowser',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped></style>
